var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmyk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 340 340",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 150,
    fill: "#45b7ef"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170 20a150 150 0 1 0 0 300z",
    fill: "#fae12a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170 20a150 150 0 1 1 0 300z",
    fill: "#333233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320 170c0-83-67-150-150-150v150z",
    fill: "#cf119b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170 20C87 20 20 87 20 170h150z",
    fill: "#24b7ef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165 0h10v340h-10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M340 165v10H0v-10z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmyk);
export default __webpack_public_path__ + "static/media/cmyk.8866b199352a5d8f307368dd01e1ae76.svg";
export { ForwardRef as ReactComponent };